import ActionTypeBasePaths from 'automation-ui-routing/ActionTypeBasePaths';

/*
 * NOTE ABOUT ROUTES IN CORE:
 * We have discussed the pros and cons or moving BasePaths into the core lib, and have enumerated some trade-offs.
 * For the time being, we have decided to move these constants in an effort to help support routing utilities,
 * so that other libraries and external teams can use this logic and consistency is ensured.
 *
 * Argument for a centralized routing model:
 * - Developer awareness of all other routes (this actually led to PR 4721)
 * - Setting constants ensures routes are exact, avoids bugs due to typos
 *
 * Argument for hard-coded, distributed model:
 * - Specific routes are still easy to grok
 * - No need for more complex dependency model or core bloat
 * - Ideally, apps/deployables should own their routes
 * - While more prone to inconsistencies or typos, in theory, breakage should generally be obvious
 */

export default Object.assign({
  INDEX: '/',
  VIEW: 'view',
  PLATFORM: 'platform',
  FLOW: 'flow',
  SPLASH: 'signup',
  EDIT: 'edit',
  PREVIEW: 'preview',
  PERFORMANCE: 'performance',
  ENROLLMENT_HISTORY_PAGE: 'enrollment-history',
  ENROLLMENT_CONVERSION: 'aggregate-performance',
  GOALS: 'goals',
  HISTORY: 'history',
  EVENT: 'event',
  DETAILS: 'details',
  ACTION_LOGS: 'action-logs',
  RISKS: 'risks',
  RISK_DETAILS: 'risk-details',
  FILTERS: 'filters',
  SETTINGS: 'settings' /* platform settings page routes */,
  ENROLLMENT_CHECKS: 'enrollment-checks',
  HYBRID_TEST_FLOW: 'test-flow',
  PLATFORM_FLOW_SUPPRESSIONS: 'suppressions',
  PLATFORM_FLOW_GENERAL_SETTINGS: 'general',
  PLATFORM_FLOW_NOTIFICATIONS_SETTINGS: 'notifications',
  PLATFORM_ENROLLMENT: 'enrollment',
  PLATFORM_UNENROLLMENT: 'unenrollment',
  RESTORE_WORKFLOWS: 'restore-workflows',
  LOG_EVENTS: 'log-events',
  AUDIT_EVENTS: 'audit-events',
  BRANCH_DIAGNOSE: 'branch-diagnose',
  CHANGES: 'changes',
  CHANGES_ROLLUP: 'changes-rollup',
  ENROLLMENTS: 'enrollments',
  ENROLLMENT_DETAILS: 'enrollment-details',
  ENROLLMENT_DIAGNOSE: 'enrollment-diagnose',
  ENROLLMENT_HISTORY: 'enrollment-history',
  SCHEDULED: 'scheduled' /* scheduled enrollment route suffix */,
  REVISIONS: 'revisions',
  FLOW_DETAILS: 'flow-details',
  ACTION_SET: 'action-set',
  /* AI generated workflows */
  AI_ASSISTANT: 'ai-assistant',
  AI_COLLABORATE: 'ai-collaborate',
  GENERATE: 'generate',
  /* classic settings page routes */
  GENERAL_SETTINGS: 'general',
  UNENROLL_SETTINGS: 'unenrollment',
  CREATE_WORKFLOW: 'create',
  CREATE_WORKFLOW_STANDARD: 'new',
  CREATE_WORKFLOW_TEMPLATE: 'template',
  CREATE_WORKFLOW_TEMPLATE_PARAMETERIZED: 'select',
  CREATE_WORKFLOW_TEMPLATE_PARAMETERIZED_WIZARD: 'build',
  REVIEW: 'review'
}, ActionTypeBasePaths, {
  PLATFORM_FLOW_CONFIGS: 'actions',
  FLOW_CANVAS_ENROLLMENT_CONFIG: 'triggers',
  PLATFORM_FLOW_EMAIL_ACTION_EDITOR: 'editor',
  PLATFORM_FLOW_TEST_FLOW: 'test-flow',
  PLATFORM_FLOW_DATA_SOURCE_EDIT: 'data-source-edit',
  PLATFORM_FLOW_MOVE_ACTION: 'move-action',
  PLATFORM_FLOW_OPTIMIZE: 'optimize',
  PLATFORM_FLOW_REVISION: 'revision',
  /* embedded routes */
  EMBEDDED_CONFIGS: 'embedded-configs',
  EMBEDDED_CONFIGS_BY_UUID: 'embedded-configs-by-uuid',
  EMBEDDED_CANVAS: 'embedded-canvas',
  EMBEDDED_CANVAS_MULTI: 'embedded-canvas-multi',
  EMBEDDED_CANVAS_BY_UUID: 'embedded-canvas-by-uuid',
  EMBEDDED_NEW_FLOW: 'embedded-new-flow',
  EMBEDDED_CONTEXTUAL_AUTOMATION_FLOW: 'embedded-contextual-automation-flow',
  EMBEDDED_FLOW_PREVIEW: 'embedded-flow-preview',
  /* acceptance-test-routes */
  EMBEDDED_TEST: 'embedded-test',
  EMBEDDED_SINGLE_FLOW_ID_TEST: 'embedded-single-flow-id-test',
  EMBEDDED_MULTI_FLOW_TEST: 'embedded-multi-flow-test',
  EMBEDDED_COLLAPSED_FLOWS_TEST: 'embedded-collapsed-flows-test',
  /* multi-flow mode*/
  MULTI_FLOW_MODE: 'multi'
});